var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoad)?_c('div',{staticClass:"box-placeholder"},[_c('div',{staticClass:"excerpt"},_vm._l((_vm.loops),function(i){return _c('div',{key:i.toString(),staticClass:"text",attrs:{"id":i}})}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b451c2fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/PlaceholderContent.vue
// module id = null
// module chunks = 